/* Lushe Hair Co. — bespoke motion chokepoint (hfb)
   One IntersectionObserver drives every reveal. No motion library.
   Reduced-motion: elements are shown immediately (CSS handles the visual). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    nodes.forEach(function (n) { n.classList.add('is-visible'); });
  }

  function init() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.lushe-reveal'));
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (n, i) {
      // gentle stagger for grouped reveals sharing a parent (catalog-spread feel)
      if (n.hasAttribute('data-reveal-stagger')) {
        n.style.setProperty('--lushe-reveal-delay', (Math.min(i, 6) * 0.06) + 's');
      }
      io.observe(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-scan when Shopify theme editor injects/reorders sections
  document.addEventListener('shopify:section:load', init);
})();
